export default function About() {
  return (
    <section id="about" className="fade-in">
      <h2>About</h2>
      <p>
        I'm a student developer passionate about software development, cloud technologies, and DevOps. I enjoy creating projects, experimenting with new tools, and constantly improving my skills. Whether it's writing clean code, deploying applications, or automating workflows, I love the process of learning and building. I'm still growing in this journey, but I'm dedicated, curious, and excited to turn my knowledge into real-world solutions.
      </p>
    </section>
  );
}